import { memo } from 'react';
import { Link } from '@mui/material';

type LinkAddressProps = {
  address: string;
};

const LinkAddress = (props: LinkAddressProps) => {
  const { address } = props;
  const URL = 'https://maps.google.com/maps/place/';
  return (
    <Link
      href={`${URL}${address}`}
      target='_blank'
      rel='noopener noreferrer'
      className='hover:underline text-[#007AFC]'
    >
      {address}
    </Link>
  );
};

export default memo(LinkAddress);
